import styled from 'styled-components'
import { Typography } from 'antd'
import { Link } from 'react-router-dom'
import { MEDIA, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

/**
 * Styled components for Logo
 * Replaces inline styles with reusable, semantic components
 */

const { Text } = Typography

interface LogoTextProps {
  $color?: string
}

// Logo link without text decoration
export const LogoLink = styled(Link)`
  text-decoration: none;
  flex-shrink: 0;
`

// Logo text with theme-aware color and Poppins font
export const LogoText = styled(Text)<LogoTextProps>`
  &.ant-typography {
    font-family: 'Poppins', sans-serif;
    font-size: ${TYPOGRAPHY.body.fontSize};
    font-weight: ${FONT_WEIGHT.bold};
    color: ${(props) => props.$color};
    margin-left: -15px;
    white-space: nowrap;

    ${MEDIA.mobile} {
      font-size: ${TYPOGRAPHY.body.fontSize};
      margin-left: 0;
    }
  }
` as typeof Text
